/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useContext, useEffect, useRef, useState } from "react";
import Map from "../Components/Maps/LiveMap";
import moment from "moment";
import { UserIcon } from "@heroicons/react/24/outline";
import CountUp from "react-countup";
import Card from "../Components/Card";
import Badge from "../Components/Badge";
import SocketContext from "../Contexts/SocketContext";
import OsSystemSelect from "../Components/FormElements/OsSystemSelect";

const FlightMap = () => {
  const mapRef = useRef(null);
  const [acitvePlayerCount, setAcitvePlayerCount] = useState(0);
  const selectedFlightId = useRef(null);
  const showRoutes = useRef(false);
  const popupRef = useRef(null);
  const previousCountRef = useRef(0);
  const flightsData = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [flight, setFlight] = useState(null);
  const socket = useContext(SocketContext);
  const [selectedOsSystem, setSelectedOsSystem] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const handleOsChange = (value) => {
    if (value && flight?.os_system !== value) {
      selectedFlightId.current = null;
      setFlight(null);
    }
    setSelectedOsSystem(value);
  };

  useEffect(() => {
    previousCountRef.current = acitvePlayerCount;
  }, [acitvePlayerCount]);

  useEffect(() => {
    setFlight(
      flightsData.current?.find(
        (flight) => flight.flight_id === selectedFlightId.current
      )
    );
  }, [flightsData.current, selectedFlightId, refresh]);

  useEffect(() => {
    if (socket && mapLoaded && mapRef.current) {
      socket.emit("showLiveMap", selectedOsSystem, selectedFlightId.current);
    }
    return () => {
      socket?.emit("stopShowingLiveMap");
    };
  }, [
    socket,
    selectedFlightId.current,
    selectedOsSystem,
    mapRef.current,
    mapLoaded,
  ]);

  useEffect(() => {
    if (socket) {
      socket.on("flightData", (data, latestRoute) => {
        flightsData.current = data;
        if (selectedFlightId.current) {
          setFlight(
            data.find((flight) => flight.flight_id === selectedFlightId.current)
          );
        }
        setAcitvePlayerCount(data.length);
        let geoJson = {
          type: "FeatureCollection",
          features: data.map((flight) => {
            if (
              selectedFlightId?.current === flight.flight_id &&
              popupRef.current
            ) {
              mapRef.current.panTo([flight.lng, flight.lat]);
              popupRef?.current?.setLngLat([flight.lng, flight.lat]);
            }
            return {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [flight.lng, flight.lat],
              },
              properties: {
                opacity:
                  flight.speed > 0 ||
                  moment(flight.created_at).isBefore(
                    moment().subtract(
                      process.env.REACT_APP_USER_INACTIVE_AFTER_SECONDS,
                      "seconds"
                    )
                  )
                    ? 1
                    : 0.5,
                icon: moment(flight.created_at).isBefore(
                  moment().subtract(
                    process.env.REACT_APP_USER_INACTIVE_AFTER_SECONDS,
                    "seconds"
                  )
                )
                  ? `red_acft_${flight.acft}`
                  : `acft_${flight.acft}`,
                fallback_icon: `acft_fallback`,
                rotation: 90 - flight.heading,
                id: flight.flight_id,
              },
            };
          }),
        };
        mapRef.current.getSource("points")?.setData(geoJson);
        if (latestRoute) {
          let routeGeoJson = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {},
                geometry: JSON.parse(latestRoute),
              },
            ],
          };
          mapRef.current.getSource("route")?.setData(routeGeoJson);
        } else {
          mapRef.current.getSource("route")?.setData({
            type: "FeatureCollection",
            features: [],
          });
        }
      });
      // set route
    }
  }, [socket, mapRef.current]);

  return (
    <>
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-2xl font-bold mb-8">Live Map</h1>
          <p className="mb-4 text-sm text-gray-600 whitespace-pre-line w-2/3">
            Explore real-time flights from users around the globe engaging with
            the flight simulator, with options to filter by the operating system
            for a tailored view.
          </p>
          <div className="max-w-md mb-4"></div>
        </div>
        <div className="flex items-center space-x-4">
          <div>
            <OsSystemSelect onSelect={handleOsChange} showAllOption />
          </div>
          <div className="flex items-center space-x-12">
            <div className="flex items-center space-x-2  border-gray-200 rounded-md p-1 px-4">
              <div className="bg-red-600 shadow shadow-red-600 animate-pulse rounded-full h-4 w-4"></div>
              <CountUp
                start={previousCountRef.current}
                end={acitvePlayerCount}
              />
              {/* <p>{acitvePlayerCount}</p> */}
              <UserIcon className="h-8 w-8" />{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="h-full w-full relative mt-4 pb-24">
        <Map
          onMapClick={() => {
            setFlight(null);
            showRoutes.current = false;
            selectedFlightId.current = null;
            setRefresh((prev) => !prev);
          }}
          onAirplaneSelect={(id) => {
            selectedFlightId.current = id;
            showRoutes.current = true;
            setRefresh((prev) => !prev);
          }}
          onLoad={() => setMapLoaded(true)}
          ref={mapRef}
        />

        <div className="absolute right-0 bottom-32 mr-[10px] ">
          <Card>
            <div className="space-y-4 text-sm">
              <div className="flex  items-center space-x-4">
                <img
                  src={`Images/acft_markers/acft_a320.png`}
                  className="h-6 w-6"
                  alt="active"
                />
                <p>Actively Flying</p>
              </div>

              <div className="flex  items-center space-x-4">
                <img
                  src={"Images/acft_markers/acft_a320.png"}
                  className="h-6 w-6 opacity-50"
                  alt="grounded"
                />
                <p>Active but grounded</p>
              </div>

              <div className="flex  items-center space-x-4">
                <img
                  src={"Images/acft_markers/red_acft_a320.png"}
                  className="h-6 w-6 "
                  alt="inactive"
                />
                <p>Inactive</p>
              </div>
            </div>
          </Card>
        </div>
        {flight && (
          <div className="text-sm absolute inset-4 max-w-max max-h-max">
            <Card>
              {moment(flight.created_at).isBefore(
                moment().subtract(
                  process.env.REACT_APP_USER_INACTIVE_AFTER_SECONDS,
                  "seconds"
                )
              ) && (
                <div className="mb-4">
                  <Badge color="red" label="Inactive" />
                </div>
              )}
              <div className="grid grid-cols-2">
                <p>Aircraft </p>
                <p className="font-bold">{flight.acft}</p>
              </div>
              <div className="grid grid-cols-2">
                <p>Altitude: </p>
                <p className="font-bold">
                  {parseFloat(flight.altitude).toFixed(2)} m
                </p>
              </div>

              <div className="grid grid-cols-2">
                <p>Speed: </p>
                <p className="font-bold">
                  {parseFloat(flight.speed).toFixed(2)} m/s
                </p>
              </div>
              <div className="grid grid-cols-2">
                <p>Heading: </p>
                <p className="font-bold">{flight.heading} °</p>
              </div>

              <span className="text-xs  ">
                <span className="flex items-center justify-between space-x-4 mt-2 pt-2  border-t  border-gray-200">
                  <p className="text-gray-500">{flight.user_id}</p>
                  <Badge label={flight.os_system} color="blue" />
                </span>

                <p className="mt-1">
                  Started playing:{" "}
                  {moment(flight.flight_start).format("YYYY-MM-DD, HH:mm")}
                </p>
              </span>
              <div className="mt-4">
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    className="checkbox-routeinfo"
                    type="checkbox"
                    checked={
                      showRoutes.current &&
                      flight.flight_id === selectedFlightId.current
                    }
                    onChange={(e) => {
                      showRoutes.current = e.target.checked;
                      setRefresh((prev) => !prev);
                    }}
                  />
                  <span className="ml-3 text-sm font-medium text-gray-900 ">
                    Show Route
                  </span>
                </label>
              </div>
            </Card>
          </div>
        )}
      </div>
    </>
  );
};

export default FlightMap;
